export const handleCustomUDL = (eventName: string, properties?: Object, eventCallback?: () => void, eventTimeout = 800):void => {

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "genericEvent",
    event_name: eventName,
    ...(properties && { [eventName]: properties }),
    ...(eventCallback && eventCallback),
    // eventTimeout is only used is eventCallback is defined
    ...(eventCallback && { eventTimeout })
  });
};
